import React, { useRef } from "react";

import styled from "styled-components";

import Button, { BUTTON_STYLES } from "components/atoms/button";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 4px;
    width: 150px;
    background-color: var(--color-White);
    border: solid 2px var(--color-Outline);
    border-radius: 8px;
    overflow: hidden;
    z-index: 10;
`;

const ButtonDivider = styled.span`
    display: block;
    margin: 8px auto;
    height: 1px;
    width: calc(100% - 32px);
    background-color: var(--color-Line);
`;

const HiddenFileInput = styled.input`
    display: none;
`;

function ReferenceAddMenu(props) {
    const fileRef = useRef(null);
    const { fileAddHandler, onOpenBibtex, onOpenArxiv, onOpenDoi, onOpenPubmed, onOpenForm } = props;

    return (
        <Container>
            <HiddenFileInput
                type={"file"}
                ref={fileRef}
                accept={"application/pdf"}
                name={"file"}
                multiple
                onChange={(e) => fileAddHandler(e)}
            />
            <Button
                {...BUTTON_STYLES.dropdownItemText}
                buttonText={"PDF로 추가"}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    fileRef.current.click();
                }}
            />
            <ButtonDivider />
            {/* BibTeX로 추가 */}
            <Button {...BUTTON_STYLES.dropdownItemText} buttonText={"BibTeX로 추가"} onClick={onOpenBibtex} />
            <ButtonDivider />
            {/* ArXiv ID, DOI, PubMed ID로 추가 */}
            <Button {...BUTTON_STYLES.dropdownItemText} buttonText={"ArXiv ID로 추가"} onClick={onOpenArxiv} />
            <Button {...BUTTON_STYLES.dropdownItemText} buttonText={"DOI로 추가"} onClick={onOpenDoi} />
            <Button {...BUTTON_STYLES.dropdownItemText} buttonText={"PubMed ID로 추가"} onClick={onOpenPubmed} />
            <ButtonDivider />
            {/* 직접 추가 */}
            <Button {...BUTTON_STYLES.dropdownItemText} buttonText={"직접 추가"} onClick={onOpenForm} />
        </Container>
    );
}

export default ReferenceAddMenu;
